import { render, staticRenderFns } from "./common-left-menu.vue?vue&type=template&id=5a65e667&scoped=true&"
import script from "./common-left-menu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./common-left-menu.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./common-left-menu.vue?vue&type=style&index=0&id=5a65e667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65e667",
  null
  
)

export default component.exports